import React, { useMemo, useRef } from 'react';
import { SERVICE_TASK, serviceTask } from "../../../../../util/varibles/constants";
import { IService, IService2, IUnitDisease } from "../../../../../util/varibles/interface";
import Tabs from "../../../../Basic/Tabs";
import Icon, { ICON_NAME } from "../../../../Icon";
import UnitDisease from "../../../../Operation/FishDisease/UnitDisease";
import LineInfo from "../../_component/LineInfo";
import styles from "./style.module.scss";

const DataInfo: React.FC<{ data?: { id: string, taskIds: { type: SERVICE_TASK | string, name?: string }[], unit_diseases?: IUnitDisease }, notes: Record<string, Record<string, string[]>> }> = ({ data, notes }) => {
    if (!data)
        return null;

    const { taskIds, unit_diseases, id } = data;
    return <div>
        {unit_diseases && <LineInfo label="Unit diseases" className='mb-1' icon>
            <>
                <Icon className="mt-[2px]" icon={ICON_NAME.DISEASE} />
                <UnitDisease unit={{ unit_diseases }} />
            </>
        </LineInfo>}
        <div className={styles.tasks}>
            <div className='mr-[10px]' data-lev='title'>Task:</div>
            <div data-lev='list'>
                {Array.from(new Set(taskIds)).map(item => {
                    const { type, name } = item;
                    const { [type]: note = [] } = notes[id] || {}
                    return <div key={type} className='flex items-center gap-1'>
                        <label >
                            {name ?? serviceTask[type]?.name}
                        </label>
                        {note.length > 0 && <div className='flex items-center'>
                            <Icon icon={ICON_NAME.NOTE} />
                            <span className='ml-[5px]'>{Array.from(new Set(note)).map(item => item).join("; ")}</span>
                        </div>}
                    </div>
                }
                )}
            </div>
        </div>
    </div>
}

interface IProps {
    operation: IService2
}

const ServiceInfo: React.FC<IProps> = ({ operation }) => {
    const { tasks = [], sub_operations: rootSubs } = operation as IService;
    const note = useRef<Record<string, Record<string, string[]>>>({});

    const tabs = useMemo(() => {
        const saveNote = (value: string, id: string, type: SERVICE_TASK | string) => {
            if (value.length > 0)
                note.current[id] = {
                    ...note.current[id] || {},
                    [type]: [...note.current?.[id]?.[type] || [], value]
                }
        }
        const { location_id, location_name } = tasks[0];

        const group = tasks.reduce((rs: { [id: string]: ({ type: SERVICE_TASK | string, name?: string })[] }, item) => {
            const { location_id, sub_operations = [], type, note, name } = item;
            if (!type)
                return rs;

            if (sub_operations.length > 0) {
                sub_operations.forEach(sub => {
                    rs[sub.id] = [...rs[sub.id] || [], { type, name }]
                    saveNote(note || "", sub.id, type)
                })
            } else {
                rs[location_id] = [...rs[location_id] || [], { type, name }]
                saveNote(note || "", location_id, type)
            }
            return rs;
        }, {});
        const value: { name: string, data: any }[] = []
        if (group[location_id]) {
            value.push({
                name: location_name,
                data: { id: location_id, taskIds: group[location_id] }
            })
        }
        rootSubs.forEach(item => value.push({
            name: item.unit_id,
            data: { ...item, taskIds: group[item.id] }
        }))

        return value
    }, [tasks, rootSubs]);

    return <Tabs opts={tabs}>
        <DataInfo notes={note.current} />
    </Tabs>;
};

export default ServiceInfo;